import { PartialReceptionCounts } from "@/interfaces/PartialReception";
import { CircleCheck, CircleX } from "lucide-react";
import React from "react";

interface PartialReceptionSummaryProps {
  counts: PartialReceptionCounts;
}

const PartialReceptionSummary: React.FC<PartialReceptionSummaryProps> = ({
  counts,
}) => {
  return (
    <div className="px-4 flex items-center justify-between gap-2">
      <span className="inline-flex items-center gap-1 text-sm font-medium text-emerald-700">
        <CircleCheck className="h-4 w-4" />
        {counts.accepted} accepté(s)
      </span>
      <span className="inline-flex items-center gap-1 text-sm font-medium text-red-600">
        <CircleX className="h-4 w-4" />
        {counts.refused} refusé(s)
      </span>
      <span className="text-sm text-muted-foreground">
        {counts.total} article(s)
      </span>
    </div>
  );
};

export default PartialReceptionSummary;
